import { moduleFailed } from '../utilities/_module_failure.js';
// Import general page JS files
import(`./_navbar.js`).then(module => module.init()).catch(moduleFailed('_navbar.js'));
import(`./_news.js`).then(module => module.init()).catch(moduleFailed('_news.js'));

// Import the homepage JS
import './home';
